import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Form } from "react-bootstrap";
import ColumnResizer from "react-table-column-resizer";
export function ProductTableDisplay(_param) {
    var columdisplay = _param.columdisplay, setColumDisplay = _param.setColumDisplay, setModalDisplayColumn = _param.setModalDisplayColumn, columdisplayName = _param.columdisplayName, props = _object_without_properties(_param, [
        "columdisplay",
        "setColumDisplay",
        "setModalDisplayColumn",
        "columdisplayName"
    ]);
    var SaveDisplay = function() {
        localStorage.setItem(columdisplayName, JSON.stringify(columdisplay));
        setModalDisplayColumn(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-3",
        children: [
            /*#__PURE__*/ _jsxs("table", {
                className: "column_resize_table table1 table-striped ",
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ _jsx("thead", {
                        children: /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("th", {
                                    children: "สถานะ"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "รายการแสดงผล"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 300
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("tbody", {
                        children: [
                            columdisplay.hasOwnProperty("barcode") && /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "ms-4 mt-2 mb-1",
                                            label: "",
                                            checked: columdisplay.barcode,
                                            onChange: function(e) {
                                                setColumDisplay(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        barcode: e.target.checked
                                                    });
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "บาร์โค้ด"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }),
                            columdisplay.hasOwnProperty("supplierCode") && /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "ms-4 mt-2 mb-1",
                                            label: "",
                                            checked: columdisplay.supplierCode,
                                            onChange: function(e) {
                                                setColumDisplay(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        supplierCode: e.target.checked
                                                    });
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "รหัสสินค้าผู้ขาย"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }),
                            columdisplay.hasOwnProperty("productReceived") && /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "ms-4 mt-2 mb-1",
                                            label: "",
                                            checked: columdisplay.productReceived,
                                            onChange: function(e) {
                                                setColumDisplay(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        productReceived: e.target.checked
                                                    });
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "จำนวนสินค้าที่รับแล้ว"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }),
                            columdisplay.hasOwnProperty("ums") && /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "ms-4 mt-2 mb-1",
                                            label: "",
                                            checked: columdisplay.ums,
                                            onChange: function(e) {
                                                setColumDisplay(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        ums: e.target.checked
                                                    });
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "จำนวน UMS"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }),
                            columdisplay.hasOwnProperty("productsStock") && /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "ms-4 mt-2 mb-1",
                                            label: "",
                                            checked: columdisplay.productsStock,
                                            onChange: function(e) {
                                                setColumDisplay(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        productsStock: e.target.checked
                                                    });
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "สินค้าคงเหลือ"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }),
                            columdisplay.hasOwnProperty("vat") && /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "ms-4 mt-2 mb-1",
                                            label: "",
                                            checked: columdisplay.vat,
                                            onChange: function(e) {
                                                setColumDisplay(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        vat: e.target.checked
                                                    });
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "ภาษีมูลค่าเพิ่ม"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }),
                            columdisplay.hasOwnProperty("valueIncludingTax") && /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "ms-4 mt-2 mb-1",
                                            label: "",
                                            checked: columdisplay.valueIncludingTax,
                                            onChange: function(e) {
                                                setColumDisplay(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        valueIncludingTax: e.target.checked
                                                    });
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "มูลค่ารวมภาษี"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "d-flex align-items-center pb-4 pt-5 ",
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    className: "btn-st-3 ms-auto me-3 btn",
                    onClick: function() {
                        return SaveDisplay();
                    },
                    children: "ตกลง"
                })
            })
        ]
    });
}
